<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <path class="cls-1" d="m27.45,76.62c.48.49,1.27.49,1.76.01l6.04-5.95c1.03-1.03,1.34-2.55.89-3.87l1.3-1.25c.7-.68,1.62-1.05,2.6-1.05h16.57c2.94,0,5.72-1.13,7.83-3.18.09-.08-.66.79,11.31-13.51,1.77-2.1,1.51-5.25-.59-7.03-2.09-1.76-5.22-1.51-7,.56l-7.36,7.56c-.93-1.14-2.35-1.86-3.88-1.86h-13.9c-1.98-.83-4.08-1.25-6.24-1.25-6,0-11.24,2.77-14.06,7.97-1.19-.22-2.43.13-3.33,1.03l-5.93,5.95c-.48.49-.49,1.27,0,1.76l14,14.1Zm9.33-28.32c1.91,0,3.76.38,5.49,1.14.16.07.33.1.5.1h14.16c1.35,0,2.49,1.1,2.49,2.49s-1.12,2.49-2.49,2.49h-10.17c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25h10.17c2.75,0,4.99-2.24,4.99-4.99,0-.22-.02-.44-.04-.65,7.12-7.31,8.12-8.34,8.16-8.39.89-1.05,2.47-1.18,3.51-.3,1.05.89,1.18,2.46.29,3.52l-11.18,13.37c-1.63,1.57-3.78,2.43-6.04,2.43h-16.57c-1.62,0-3.16.62-4.33,1.75l-1.06,1.02-9.77-9.77c2.28-4.28,6.57-6.72,11.89-6.72Zm-15.63,8.27c.41-.41,1.04-.49,1.54-.18.22.13-.4-.43,10.8,10.75.5.5.47,1.29,0,1.76l-5.15,5.08-12.25-12.34,5.05-5.07Z"/>
  <path class="cls-1" d="m50.88,17.34v2.12c.82.08,1.6.25,2.34.5.74.25,1.37.56,1.89.94l-1,2.74c-.56-.4-1.23-.72-1.99-.96-.77-.24-1.55-.36-2.34-.36s-1.35.1-1.67.32c-.32.22-.49.48-.49.8,0,.27.11.5.32.69.22.19.61.35,1.19.48l2.17.48c2.35.54,3.52,1.83,3.51,3.85,0,1.08-.38,1.99-1.11,2.73-.73.74-1.7,1.23-2.92,1.45l-.02,2.21-2.67-.02.02-2.15c-.67-.08-1.3-.25-1.91-.49-.61-.25-1.11-.55-1.5-.91l.96-2.57c.46.36,1,.64,1.63.85.63.2,1.3.31,2.02.31.67,0,1.19-.11,1.56-.36.37-.24.56-.55.56-.94,0-.26-.1-.47-.32-.65-.22-.17-.6-.33-1.15-.46l-2.17-.5c-2.39-.54-3.58-1.8-3.57-3.77,0-1.09.38-2,1.11-2.72s1.69-1.19,2.87-1.4l.02-2.21,2.67.02Z"/>
  <circle class="cls-2" cx="49.65" cy="26.32" r="13.31"/>
</svg>
</template>

<script>
export default {
    name: "RevenueGenerationIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #115c72;
  }
  .cls-2 {
    fill: none;
    stroke: #59c5c7;
    stroke-miterlimit: 10;
    stroke-width: 3px;
  }
</style>